import { setCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BrandDetailsPageContext } from "@insite/content-library/Pages/BrandDetailsPage";
import Link, { LinkProps } from "@insite/mobius/Link";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ChevronRight from "@ucs/Icons/ChevronRight";
import setIsLocalSelectedPLP from "@ucs/Store/Custom/SetIsLocalSelectedPLP";
import React, { FC, useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface BrandDetailsImageStyles {
    container?: InjectableCss;
    linksSection?: InjectableCss;
    link?: LinkProps;
}

const mapDispatchToProps = {
    setIsLocalSelectedPLP
}

type Props = ResolveThunks<typeof mapDispatchToProps> & WidgetProps

export const imageStyles: BrandDetailsImageStyles = {
    container: {
        css: css`
            width: 350px;
            padding: 20px 0;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                ]);
            }}
        `,
    },
    linksSection: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: column;
            & > * {
                padding: 16px 0 !important;
                border-bottom: 2px solid #ccc !important;
            }
            & > *:first-child {
                border-top: 2px solid #ccc !important;
            }
        `,
    },
    link: {
        icon: {
            iconProps: { color: "primary", size: 16, src: ChevronRight },
        },
        typographyProps: {
            size: 18,
            css: css`
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            font-size: 17px;
                        `,
                        css`
                            font-size: 17px;
                        `,
                    ]);
                }}
            `,
        },
    },
};

const styles = imageStyles;

const BrandDetailsLinks: FC<Props> = ({ setIsLocalSelectedPLP }) => {
    const { value: brand } = useContext(BrandStateContext);
    if (!brand) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.linksSection}>
                <Link data-test-selector="brandToProductPageLink" href={brand.productListPagePath} {...styles.link} onClick={() => setIsLocalSelectedPLP({ isLocalSelectedPLP: false })}>
                    {translate("Shop All {0} Products").replace("{0}", brand.name)}
                </Link>
                {brand.externalUrl && (
                    <Link data-test-selector="brandExternalUrlLink" href={brand.externalUrl} target="_blank" {...styles.link}>
                        {translate("Visit {0} Website").replace("{0}", brand.name)}
                    </Link>
                )}
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(BrandDetailsLinks),
    definition: {
        group: "Brand Details",
        icon: "Link",
        displayName: "Brand Links",
        allowedContexts: [BrandDetailsPageContext],
    },
};

export default widgetModule;
